import axios from 'axios'
import API_ENDPOINT from "../config"


export const getCreditsData  = async  (token,userId) =>  {
    let fd = new FormData();
    fd.append("token",JSON.stringify(token));
    fd.append("identity","wmhandler");
    fd.append("user_id",userId);
    // fd.append("page_no",pageNo)
    
    var res = await axios({method:"POST",url:`${API_ENDPOINT.apiUrl}adminPanel/getCredits`,data:fd})
    return res.data;
}

export const transactCredit = async (token,clientId,action,credits) =>
{
    let fd = new FormData();
    fd.append("token",JSON.stringify(token));
    fd.append("identity","wmhandler");
    fd.append("user_id",clientId);
    fd.append("action",action);
    fd.append("credits",credits);
    var res = await axios({method:"POST",url:`${API_ENDPOINT.apiUrl}adminPanel/creditTransact`,data:fd})
    return res.data;
}